import { FC } from 'react';
import { MetadataRegister, ProgressIndicator } from '~/components';
import { FormBehavior, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { AlertMessages, StepsSideAccount, showAlert, useStores } from '~/utils';
import { initialValues, validationSchema } from './schema';
import SideAccountRegister from './SideAccountRegister';
import UpdateLimit from './UpdateLimit';

export const SideAccountRegisterContainer: FC = () => {
  const navigate = useNavigate();
  const {
    clients,
    utils: { setProgressId },
  } = useStores();

  const handleFormSubmit = async (values: UpdateLimit) => {
    await clients.updateLimitToAccount(values);
    showAlert({
      message: AlertMessages.SUCCESS_UPDATE_LIMIT,
      type: 'success',
    });
    navigate(Routes.CLIENT_ACCOUNT_DETAILS, { replace: true });
  };

  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={handleFormSubmit}
    >
      <SideAccountRegister>
        <ProgressIndicator
          steps={[
            {
              id: StepsSideAccount.DATA,
              label: 'Dados da Conta',
              content: (
                <UpdateLimit
                  clientStore={clients}
                  onNavigateId={(id) => setProgressId(id)}
                />
              ),
            },
            {
              id: StepsSideAccount.META_DATA,
              label: 'Metadata',
              content: (
                <MetadataRegister onNavigateId={(id) => setProgressId(id)} />
              ),
            },
          ]}
        />
      </SideAccountRegister>
    </FormBehavior>
  );
};

export default observer(SideAccountRegisterContainer);
